// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"ItinerariesListTitle_titleContainer__qis_2"};